import { PluginFunction } from "vue";
import { container } from "@/_di/container";
import { Modules } from "@/_di/types";

export const dependencyInjectionPlugin: PluginFunction<Partial<Modules>> = (vue, modules = {}) => {
  container.register(modules);
  vue.prototype.$container = container.cradle;
};
